import type { JsonSchemaRoot } from "./types";

// JSON Schema type options
export const TYPE_OPTIONS = [
    { value: "string", label: "String" },
    { value: "number", label: "Number" },
    { value: "integer", label: "Integer" },
    { value: "boolean", label: "Boolean" },
    { value: "array", label: "Array" },
    { value: "object", label: "Object" },
    { value: "null", label: "Null" },
];

// String format options
export const STRING_FORMAT_OPTIONS = [
    { value: "", label: "None" },
    { value: "email", label: "Email" },
    { value: "uri", label: "URI/URL" },
    { value: "uuid", label: "UUID" },
    { value: "date", label: "Date (ISO 8601)" },
    { value: "time", label: "Time (ISO 8601)" },
    { value: "date-time", label: "Date-Time (ISO 8601)" },
    { value: "ipv4", label: "IPv4" },
    { value: "ipv6", label: "IPv6" },
    { value: "hostname", label: "Hostname" },
    { value: "json-pointer", label: "JSON Pointer" },
    { value: "regex", label: "Regex" },
];

// Type-specific properties that should be removed when type changes
export const TYPE_SPECIFIC_PROPS = {
    string: ["pattern", "minLength", "maxLength", "format"],
    number: [
        "minimum",
        "maximum",
        "multipleOf",
        "exclusiveMinimum",
        "exclusiveMaximum",
    ],
    integer: [
        "minimum",
        "maximum",
        "multipleOf",
        "exclusiveMinimum",
        "exclusiveMaximum",
    ],
    boolean: [],
    array: ["items"],
    object: ["properties", "required"],
    null: [],
} as const;

// Dialog state shape
export interface DialogState {
    name: string;
    type: string;
    title: string;
    description: string;
}

export const INITIAL_DIALOG_STATE: DialogState = {
    name: "",
    type: "string",
    title: "",
    description: "",
};

export type SchemaPath = (string | number)[];

export const DEFAULT_SCHEMA: JsonSchemaRoot = {
    $schema: "https://json-schema.org/draft/2020-12/json-schema-core.html",
    type: "object",
    title: "root",
};
